import { useEffect, useState } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import TotalCase from "../../../images/totalCase.svg";
import KgEntered from "../../../images/material_kg.svg";
import CaseGreen from "../../../images/case_green.svg";
import KgGreen from "../../../images/kg_green.svg";
import CasesRejected from "../../../images/rejected_case.svg";
import KgRejected from "../../../images/kg_rejected.svg";
import Datatable from "../../../components/shared/datatable/Datatable";
import { Col } from "react-bootstrap";
import Button from "../../../components/shared/buttons/button";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import {
  useGetRipeningSortingSummaryQuery,
  useGetSortingHistoryQuery,
  // useGetSortingSummaryQuery,
  useSearchSortingSelectedRecordQuery,
} from "./sortingApi";
import SortingModal from "./SortingModal";
import UpdatePendingKgModal from "./UpdatePendingKgModal";
import PendingCase from "../../../images/pendingCase.svg";
import caseRejected from "../../../images/caseRejected.svg";
import KgRejectedCase from "../../../images/kg_rejected_case.svg";
import "./sorting.css";
import useTranslator from "../../../hooks/useTranslator";
import usePermissions from "../../../hooks/usePermissions";
import { convertToUserTimezone, formatDateAndTime, formatPalletName, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT, REJECTED_KG_PER_CASE } from "../../../helpers/constants";

function Sorting() {
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [page, setPage] = useState(1);
  const [historyPage, setHistoryPage] = useState(1);
  const { checkPermission } = usePermissions();
  const [date, setDate] = useState(currentDate);
  const [addRecord, setAddRecord] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [filter, setFilter] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({ entered_date: "" });

  const handleFilterApply = (newFilters) => {
    setAppliedFilters(newFilters);
    setFilter(newFilters);
  };
  const [historyFilter, setHistoryFilter] = useState({});
  const [showUpdateKgModal, setShowUpdateKgModal] = useState(false);
  const [canEditSortingPending, setCanEditSortingPending] = useState(false);
  
  const [history, setHistory] = useState(false);
  const { 
        data: record ,
        isLoading: isSortingLoading, 
        isFetching: isSortingFetching 
      } = useSearchSortingSelectedRecordQuery(
        { 
          page: page,
          ...filter
        },
        { refetchOnMountOrArgChange: true }
      );
    
  const { 
          data: historyRecord ,
          isLoading,
          isFetching,
          isError,
          error,
          refetch   } = useGetSortingHistoryQuery(
            { 
              page:historyPage ,
              ...historyFilter
            },
            { refetchOnMountOrArgChange: true }
          );

  const { data: summaryData , isLoading:isSummaryLoading ,isFetching:isSummaryFetching } = useGetRipeningSortingSummaryQuery(
    { date },
    { refetchOnMountOrArgChange: true }
  );

  const { _t } = useTranslator();

  useEffect(() => {
    if(record?.data?.pagination?.current_page){

      setPage(record?.data?.pagination?.current_page)
    }
  }, [record])
      // console.log(record?.data?.pagination?.current_page)

  const listItems = [
    {
      label: _t("cases_enter_sorting", "Cases Enter in Sorting"),
      value: summaryData?.data.entered_cases,
      icon: TotalCase,
    },
    {
      label: _t("kg_entered_sorting", "KG Entered in Sorting"),
      value: summaryData?.data.entered_weight,
      icon: KgEntered,
    },
    {
      label: _t("cases_selected", "Cases Entered Processing"),
      value: summaryData?.data.selected_cases_count,
      icon: CaseGreen,
    },
    {
      label: _t("kg_selected", "Kg Entered Processing"),
      value: summaryData?.data.selected_weight,
      icon: KgGreen,
    },
    {
      label: _t("cases_rejected", "Cases Rejected"),
      value: summaryData?.data.rejected_cases_count,
      icon: CasesRejected,
    },
    {
      label: _t("kg_rejected", "KG Rejected"),
      value: summaryData?.data.rejected_weight,
      icon: KgRejected,
    },
    {
      label: _t("kg_evaporated", "KG Evaporated"),
      value: `${summaryData?.data.final_evaporation_percentage ?? 0}%`,
      icon: KgRejected,
    },
    {
      label: _t("kg_returned", "KG Returned"),
      value: `${summaryData?.data?.returned_cases_count || 0} ${_t(
        "cases"
      )} / ${summaryData?.data?.returned_weight || 0} ${_t("kg", "KG")}`,
      icon: KgRejected,
    },
  ];
  const handleClick = () => {
    setHistory(false);
  };
  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleHistoryPageChange = (page) => {
    setHistoryPage(page);
  }
  const handleAddSortingInfo = () => {
    setAddRecord(true);
    setModalMode("add");
    setSelectedRecord(null);
    setShowModal(true);
  };

  useEffect(() => {
    if(!isSummaryLoading && !isSummaryFetching ){
      setCanEditSortingPending(checkPermission("ripening.sorting_pending" , "update")); 
    }
  },[isSummaryLoading , isSummaryFetching])

  const handleHistory = () => {
    setHistory(true);
  };
  const columns = [
    {
      label: _t("date_entered", "Date Entered"),
      accessor: "entered_date_time",
      cell: ({ value }) => {
        return convertToUserTimezone(value);
      },
    },
    {
      label: _t("pallet_code", "Pallet Code"),
      accessor: "pallet_no",
      cell: ({ value }) => formatPalletName(value),
    },
    { label: _t("case_entered", "Case Entered"), accessor: "case_count" },
    { label: _t("weight_entered", "Weight Entered"), accessor: "weight" },
    {
      label: _t("fruit_type", "Fruit Type"),
      accessor: "fruit_name",
    }
  ];
  const handleAddRejected = () => {
    setAddRecord(true);
    setModalMode("rejected");
    setSelectedRecord(null);
    setShowModal(true);
  };
  
  const handleEditPendingKg = () => {
    setShowUpdateKgModal(true);
  };

  const historyColumns = [
    {
      label: _t("date_entered", "Date Entered"),
      accessor: "date_entered",
      cell: ({ value }) => {
        return convertToUserTimezone(value);
      },
    },
    {
      label: _t("entered_cases", "Entered Cases"),
      accessor: "total_entered_cases",
    },
    {
      label: _t("entered_kg", "Entered KG"),
      accessor: "total_entered_kg",
    },
    {
      label: _t("selected_cases", "Cases Entered Processing"),
      accessor: "total_selected_cases",
    },
    {
      label: _t("selected_kg", "Kg Entered Processing"),
      accessor: "total_selected_kg",
    },
    {
      label: _t("selected_fruit", "Selected Fruit"),
      accessor: "selected_fruits",
      cell: ({ value }) => {
        if (!value) return _t("no_data_yet", "No Data Yet");
        else return value;
      },
    },
    {
      label: _t("rejected_cases", "Rejected Cases"),
      accessor: "total_rejected_cases",
    },
    {
      label: _t("rejected_kg", "Rejected KG"),
      accessor: "total_rejected_kg",
    },
    {
      label: _t("rejected_fruit", "Rejected Fruit"),
      accessor: "rejected_fruits",
      cell: ({ value }) => {
        if (!value) return _t("no_data_yet", "No Data Yet");
        else return value;
      },
    },
  ];
  return !history ? (
    // dfgsdf
    <div>
      {addRecord && (
        <SortingModal
          show={showModal}
          setShow={setAddRecord}
          mode={modalMode}
          record={selectedRecord}
        />
      )}
      
      {showUpdateKgModal && (
        <UpdatePendingKgModal
          show={showUpdateKgModal}
          setShow={setShowUpdateKgModal}
          currentKg={summaryData?.data?.pending_cases_count_kg || 0}
        />
      )}
      

      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center pb-4">
          <h6 className="mb-0 flex-grow-1">
            {_t("sorting_overview", "Sorting Overview")}
          </h6>
          <DateSelector setDate={setDate} />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
      <div className="d-flex gap-2">
        <Col lg={8}>
            <div className="sorting-selected-table">
              <Datatable
                title={_t("selected_material_log", "Selected Material Log")}
                columns={columns}
                tableData={record?.data}
                buttons={[
                  {
                    label: _t("history", "History"),
                    onClick: handleHistory,
                    className: "borderRedBtn",
                  },
                  {
                    label: _t("add", "Add"),
                    onClick: handleAddSortingInfo,
                    icon: PlusSvg,
                  },
                ]}
                pagination
                page={page}
                onPageChange={handlePageChange}
                showFilter={handleFilterApply}
                showFilterButton={true}
                filterModule="sorting-filter"
                filters={appliedFilters}
                isLoading={isSortingLoading || isSortingFetching}
              />
            </div>
        </Col>
        <Col lg={4}>
          <div className="overview mb-3">
            <div className="d-flex gap-2 align-items-center">
              <h5 className="flex-grow-1 mb-0 pb-4">
                {_t("sorting_pending", "Sorting Pending")}
              </h5>
            </div>
            <ul className="overview cmn_card m-0 grid_sorting_wrapper">
              <GridCard
                title={_t("sorting_pending", "Sorting Pending")}
                value={`${summaryData?.data?.pending_cases_count_kg ?? 0} kg (${summaryData?.data?.pending_cases_count ?? 0} ${_t("cases_approx",'cases approx')})`}
                icon={PendingCase}
                showEdit={canEditSortingPending}
                onEdit={handleEditPendingKg}
              />
            </ul>
          </div>
          <div className="overview cmn_card mb-3">
            <div className="overview_header d-flex gap-2 align-items-center p-3">
              <div className="flex-grow-1">
                <h6 className="mb-0 ">
                  {_t("rejected_material_log", "Rejected Material Log")}
                </h6>
                <span className="small_info"> {_t("reject_kg_per_case", ":kg kg per case", { kg: REJECTED_KG_PER_CASE }) } </span>
              </div>
              <Button
                size="small"
                label={_t("add", "Add")}
                icon={PlusSvg}
                onClick={handleAddRejected}
              />
            </div>

            {/* Cases Rejected - Morning & Evening */}
          <div className="p-2">
                  <div className="rejected-card mb-3">
              <div className="d-flex align-items-center gap-3">
                <div className="rejected-icon">
                  <img src={caseRejected} alt="Cases Rejected" style={{ width: '48px', height: '48px' }} />
                </div>
                <div className="flex-grow-1">
                  <h6 className="mb-2" style={{ fontSize: '14px', color: '#666' }}>
                    {_t("cases_rejected", "Cases Rejected")}
                  </h6>
                  <div className="d-flex gap-3">
                    <div className="rejected-shift-data">
                      <span style={{ fontSize: '12px', color: '#999' }}>{_t("morning", "Morning")}</span>
                      <h5 className="mb-0" style={{ fontSize: '20px', fontWeight: '600' }}>
                        {summaryData?.data.morning_rejected_cases_count || 0}
                      </h5>
                    </div>
                    <div className="rejected-shift-data">
                      <span style={{ fontSize: '12px', color: '#999' }}>{_t("evening", "Evening")}</span>
                      <h5 className="mb-0" style={{ fontSize: '20px', fontWeight: '600', color: '#ee7225' }}>
                        {summaryData?.data.evening_rejected_cases_count || 0}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* KG Rejected - Morning & Evening */}
            <div className="rejected-card">
              <div className="d-flex align-items-center gap-3">
                <div className="rejected-icon">
                  <img src={KgRejectedCase} alt="KG Rejected" style={{ width: '48px', height: '48px' }} />
                </div>
                <div className="flex-grow-1">
                  <h6 className="mb-2" style={{ fontSize: '14px', color: '#666' }}>
                    {_t("kg_rejected", "KG Rejected")}
                  </h6>
                  <div className="d-flex gap-3">
                    <div className="rejected-shift-data">
                      <span style={{ fontSize: '12px', color: '#999' }}>{_t("morning", "Morning")}</span>
                      <h5 className="mb-0" style={{ fontSize: '20px', fontWeight: '600' }}>
                        {summaryData?.data.morning_rejected_weight || 0}
                      </h5>
                    </div>
                    <div className="rejected-shift-data">
                      <span style={{ fontSize: '12px', color: '#999' }}>{_t("evening", "Evening")}</span>
                      <h5 className="mb-0" style={{ fontSize: '20px', fontWeight: '600', color: '#ee7225' }}>
                        {summaryData?.data.evening_rejected_weight || 0}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </Col>
      </div>
    </div>
  ) : (
    <>
      <div className="breadcrumbs d-flex">
        <p onClick={handleClick}>{_t("sorting", "Sorting")} / </p>{" "}
        <span>
          <p className="current"> {_t("history", "History")}</p>
        </span>
      </div>
      <Datatable
        title={_t("selected_material_log", "Selected Material Log")}
        columns={historyColumns}
        tableData={historyRecord?.data}
        page={historyPage}
        showCount={true}
        showPegination={true}
        pagination
        onPageChange={handleHistoryPageChange}
        // showFilter={setHistoryFilter}
        showFilterButton={false}
        filterModule="sorting-filter"
        // pageLimit="1"
        isLoading={isLoading || isFetching}
      />
    </>
  );
}

export default Sorting;
